module.exports = __webpack_public_path__ + "static/media/Quicksand-Regular.a1afbfae.eot";